module.exports = __webpack_public_path__ + "img/b6646f1.png";